.heatedLivingAreaAlert {
  margin-top: -20px;
  text-align: left;
  margin-bottom: 30px;
}
